import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import MuuriGrid from "muuri";
import "./style.css";

import { addToQueue, changePlaylistTheme, playSong } from "./actions";
import { AccountContext } from "../../../provider/account";
import PlaylistService from "../../../service/playlist-service";

import SongItem from "./song-item";
import { Box, Row, Text, Gap, Img, FontIcon } from "../../../comps";

const ListWrapper = styled(Box)`
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export default ({ playlist, savedSongs, refresh, handleAddToQueue }) => {
  const { songs, id: playlistId } = playlist;
  const [userInfo] = useContext(AccountContext);
  const { username, isLoggedIn } = userInfo;

  useEffect(() => {
    const grid = new MuuriGrid(".grid", {
      dragEnabled: true,
      layout: { fillGaps: true, alignLeft: true, alignTop: true },
    });
  }, [songs]);

  const handleDelete = async (song) => {
    const isDeleted = await PlaylistService.deleteSongs({
      id: playlistId,
      songs: [song.videoId],
    });
    if (isDeleted) refresh();
  };

  const handleSaveState = async (song) => {
    const saved = savedSongs[song.videoId];
    if (saved) {
      const isDeleted = await PlaylistService.deleteSongs({
        id: `${username}_saved`,
        songs: [song.videoId],
      });
      if (isDeleted) refresh();
    } else {
      const isAdded = await PlaylistService.addSongs({
        id: `${username}_saved`,
        songs: [song],
      });
      if (isAdded) refresh();
    }
  };

  return (
    <ListWrapper>
      <div class="grid">
        {songs.map((song, idx) => {
          if (!song) return <></>;
          return (
            <SongItem
              song={song}
              saved={savedSongs[song.videoId] && true}
              onSaveChange={() => {
                handleSaveState(song);
              }}
              onDelete={() => {
                handleDelete(song);
              }}
              handlePlay={() => {
                playSong({ queue: songs, idx });
              }}
              setAsTheme={async () => {
                const done = await changePlaylistTheme({
                  id: playlistId,
                  song,
                });
                if (done) refresh();
              }}
              handleAddToQueue={() => {
                addToQueue({ songs: [song] });
              }}
            />
          );
        })}
      </div>
    </ListWrapper>
  );
};
